import { render, staticRenderFns } from "./LinhaDeDadosResumo.vue?vue&type=template&id=2c5312a7&scoped=true"
import script from "./LinhaDeDadosResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeDadosResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeDadosResumo.vue?vue&type=style&index=0&id=2c5312a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5312a7",
  null
  
)

export default component.exports